<ng-container *ngIf="vehicleType === internationalInsuranceVehicleTypeEnum.Caravan">
    <h3 *ngIf="showTitle">Groene Kaart caravan</h3>
    <p>
        Gaat u op pad met een caravan? Dan kunt u de Groene Kaart hier aanvragen. Schade die u maakt met een
        aangekoppelde caravan is verzekerd door de WA-dekking van uw Autoverzekering. De Groene Kaart is 1 jaar geldig
        vanaf nu.
    </p>
</ng-container>

<ng-container *ngIf="vehicleType === internationalInsuranceVehicleTypeEnum.Trailer">
    <h3 *ngIf="showTitle">Groene Kaart aanhanger</h3>
    <p>
        Gaat u op pad met een aanhanger? Dan kunt u de Groene Kaart hier aanvragen. Schade die u maakt met een
        aangekoppelde aanhanger is verzekerd door de WA-dekking van uw Autoverzekering. De Groene Kaart is 1 jaar geldig
        vanaf nu.
    </p>
</ng-container>

<div class="alert alert-warning" *ngIf="isDisabled">
    <wuc-icon icon="privacy" size="m"></wuc-icon>
    <p *ngIf="purchasedProduct?.productId === productIdEnum.Car">
        Zodra u een ingangsdatum voor verzekering
        {{ purchasedProduct?.product?.car?.licensePlate | kenteken }} heeft opgegeven kunt u hier de Groene Kaart
        downloaden.
    </p>
    <p *ngIf="purchasedProduct?.productId === productIdEnum.Moped">
        Zodra u een ingangsdatum voor verzekering
        {{ purchasedProduct?.product?.moped?.licensePlate | kenteken }} heeft opgegeven kunt u hier de Groene Kaart
        downloaden.
    </p>
    <p *ngIf="purchasedProduct?.productId === productIdEnum.Motorcycle">
        Zodra u een ingangsdatum voor verzekering
        {{ purchasedProduct?.product?.motorcycle?.motorVehicleMake | capitalize }} heeft opgegeven kunt u hier de Groene
        Kaart downloaden.
    </p>
    <p *ngIf="purchasedProduct?.productId === productIdEnum.Caravan">
        Zodra u een ingangsdatum voor verzekering
        {{ purchasedProduct?.product?.caravan.licensePlate | kenteken }} heeft opgegeven kunt u hier de Groene Kaart
        downloaden.
    </p>
</div>

<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <ng-container *ngIf="!isCaravanInsured">
        <wuc-form-field>
            <wuc-form-field-label *ngIf="vehicleType === internationalInsuranceVehicleTypeEnum.Caravan">Kenteken caravan
            </wuc-form-field-label>
            <wuc-form-field-label *ngIf="vehicleType === internationalInsuranceVehicleTypeEnum.Trailer">Kenteken
                aanhanger
            </wuc-form-field-label>
            <wuc-input-license-plate-nl formControlName="licensePlate"
                                        id="licensePlate-{{ vehicleType }}{{ purchasedProduct?.productSequenceNumber }}"
                                        placeholder="00-AB-CD"
            ></wuc-input-license-plate-nl>
        </wuc-form-field>
        <wuc-form-field [hasNoState]="true" *ngIf="errors?.length && !showOptions">
            <wuc-form-field-label></wuc-form-field-label>
            <ng-container [ngTemplateOutlet]="errorDisplay"></ng-container>
        </wuc-form-field>
    </ng-container>
    <ng-container *ngIf="showOptions">
        <wuc-form-field *ngIf="!isCaravanInsured">
            <wuc-form-field-label>Merk</wuc-form-field-label>
            <wuc-input-text formControlName="vehicleBrand"
                            id="vehicleBrand{{ vehicleType }}{{ purchasedProduct?.productSequenceNumber }}"></wuc-input-text>
        </wuc-form-field>
        <wuc-form-field>
            <wuc-form-field-label>Hoe wilt u de Groene Kaart hebben?</wuc-form-field-label>
            <wuc-input-radio formControlName="format" [value]="internationalInsuranceVehicleFormatEnum.Pdf"
                             id="formatPdf{{ vehicleType }}{{ purchasedProduct?.productSequenceNumber }}">download
            </wuc-input-radio>
            <wuc-input-radio formControlName="format" [value]="internationalInsuranceVehicleFormatEnum.Email"
                             id="formatPdf{{ vehicleType }}{{ purchasedProduct?.productSequenceNumber }}">e-mail
            </wuc-input-radio>
        </wuc-form-field>

        <wuc-form-field [hasNoState]="true" *ngIf="errors?.length">
            <wuc-form-field-label></wuc-form-field-label>
            <ng-container [ngTemplateOutlet]="errorDisplay"></ng-container>
        </wuc-form-field>
    </ng-container>

    <wuc-alert text="Uw Groene Kaart is gedownload" icon="download-international-insurance-card" type="neutral"
               *ngIf="downloadSuccess"></wuc-alert>

    <wuc-alert text="Uw Groene Kaart is naar u gemaild" icon="mail" type="neutral"
               *ngIf="emailSuccess"></wuc-alert>

    <wuc-form-field [hasNoState]="true">
        <wuc-form-field-label></wuc-form-field-label>
        <wuc-button [isSubmitButton]="true" [isFullWidth]="true" [disabled]="loading">
            Groene Kaart opvragen
        </wuc-button>
    </wuc-form-field>
</form>


<ng-template #errorDisplay>
    <wuc-balloon backgroundStyle="secondary" arrowPosition="topLeft" padding="medium" [hasCloseIcon]="false"
                 [isFullWidth]="true">
        <wuc-list icon="cross">
            <ng-container *ngFor="let error of errors">
                <wuc-list-item>{{ error }}</wuc-list-item>
            </ng-container>
        </wuc-list>
    </wuc-balloon>
</ng-template>
